import { win98 } from './win98/registration.js';
import { tfiFriday } from './tfi-friday/registration.js';
import { blackYellow } from './black-yellow/registration.js';
import { halloween } from './halloween/registration.js';
import { ffsArms } from './ffs-arms/registration.js';
import { christmas } from './christmas/registration.js';
export const STREAM_THEMES = Object.freeze([
    win98,
    tfiFriday,
    blackYellow,
    halloween,
    ffsArms,
    christmas,
]);
export function readStreamTheme(value) {
    return STREAM_THEMES.find((theme) => theme.id === value);
}
export function selectableStreamThemes() {
    return STREAM_THEMES.filter((theme) => theme.selectable && theme.lifecycle === 'ready');
}
export function readSelectableStreamThemeId(value) {
    return selectableStreamThemes().find((theme) => theme.id === value)?.id ?? null;
}
export function streamThemeLabel(value) {
    return readStreamTheme(value)?.displayName ?? String(value ?? '');
}
//# sourceMappingURL=registry.js.map